

































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import { PrivacyProperties } from 'frontend/types';
import FlatpageLegalBase from 'frontend/views/flatpages/FlatpageLegalBase.vue';
import CustomChoiceElement from 'frontend/components/forms/CustomChoiceElement.vue';

@Component({
  metaInfo() {
    return {
      title: 'Cookie Policy',
    };
  },
  components: {
    FlatpageLegalBase,
    CustomChoiceElement,
  },
  computed: {
    ...mapGetters('globals', ['privacyProperties']),
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class CookiePolicy extends Vue {
  private privacyProperties!: PrivacyProperties;
  private thirdPartyCookiesEnabled = true;
  private changingThirdPartyCookieSettings = false;

  private created(): void {
    this.thirdPartyCookiesEnabled =
      !this.privacyProperties.third_party_cookies_disabled && !this.privacyProperties.under_17;
  }

  private get thirdPartyCookiesCheckboxEnabled(): boolean {
    return this.thirdPartyCookiesEnabled && !this.privacyProperties.under_17;
  }

  private get thirdPartyCookiesCheckboxLocked(): boolean {
    return this.changingThirdPartyCookieSettings || this.privacyProperties.under_17;
  }

  private async toggleThirdPartyCookies(e: Event): Promise<any> {
    if (this.thirdPartyCookiesCheckboxLocked) {
      return;
    }
    const checkbox: HTMLFormElement =
      (e.target as HTMLFormElement) || (this.$refs.thirdPartyCookiesCheckbox as HTMLFormElement);

    this.changingThirdPartyCookieSettings = true;
    await this.$store.dispatch('globals/toggleThirdPartyCookies', checkbox.checked);
    this.changingThirdPartyCookieSettings = false;
  }
}
